import React from "react";
import { Box, RadioGroup } from "@mui/material";
import { DotLegalHeader, DotLegalRadioButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoUnknownAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

export interface IncidentLogYesNoUnknownAnswerFieldProps {
    label: string;
    answer?: YesNoUnknownAnswer | null;
    onChange: (answer: YesNoUnknownAnswer) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogYesNoUnknownAnswerField(props: IncidentLogYesNoUnknownAnswerFieldProps) {
    const { translateString } = useTranslation();

    return (
        // Same spacing as IncidentLogNotificationAnswerField: the DotLegal field below brings its own top margin.
        <Box sx={{ mt: 2 }}>
            <DotLegalHeader marginBottom={0} headerStyle={"small"}>
                {props.label}
            </DotLegalHeader>
            <RadioGroup row value={props.answer ?? null} onChange={(e) => props.onChange(Number((e.target as HTMLInputElement).value) as YesNoUnknownAnswer)}>
                <DotLegalRadioButton value={YesNoUnknownAnswer.Yes} labelPlacement="end" label={translateString("yes")} disabled={props.disabled} />
                <DotLegalRadioButton value={YesNoUnknownAnswer.No} labelPlacement="end" label={translateString("no")} disabled={props.disabled} />
                <DotLegalRadioButton value={YesNoUnknownAnswer.Unknown} labelPlacement="end" label={translateString("unknown")} disabled={props.disabled} />
            </RadioGroup>
            {props.errorText && <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main })}>{props.errorText}</Box>}
        </Box>
    );
}

export default IncidentLogYesNoUnknownAnswerField;
